import { useEffect } from "react";
import { notifyPageView } from "../../analytics/useAnalyticsEventTracker";
import { EMPTY_MESSAGES, EMPTY_MESSAGE_IMAGES } from "../../constants";
import { stateType } from "../../state";
import { EmptyMessage } from "../Common/EmptyMessage";
import { useStyles } from "../DataIngestion/DataIngestion";
import { DeletePopup } from "./DeletePopup";
import { PersonaPopup } from "./PersonaPopup";
import { PersonaPredictionBox } from "./PersonaPredictionBox";
import { PersonaSelectBox } from "./PersonaSelectBox";
import { PredictedValueBox } from "./PredictedValueBox";
import { setMetaTags } from "../../helpers/pageMeta";

export function PersonaPrediction({ state }: stateType) {
	let classes = useStyles();
	useEffect(() => {
		setMetaTags();
		window.scrollTo(0, 0);
		notifyPageView("Persona Prediction Page", window.location.pathname);
	}, []);
	if (state.saveState.savedModels.length === 0) {
		return (
			<EmptyMessage
				image={EMPTY_MESSAGE_IMAGES.pleaseTrain}
				message1={EMPTY_MESSAGES.train1}
				message2={EMPTY_MESSAGES.train2}
			></EmptyMessage>
		);
	} else {
		return (
			<div className={classes.root}>
				<div className={classes.grid}>
					<div className={classes.title}>Persona Prediction</div>
				</div>
				<div className={classes.grid}>
					<div className={classes.subTitle}>
						Make predictions from persona characteristcs.
					</div>
				</div>
				<div className={classes.grid}>
					<PredictedValueBox state={state}></PredictedValueBox>
				</div>
				<div className={classes.divider2}></div>
				<div className={classes.grid}>
					<PersonaSelectBox state={state}></PersonaSelectBox>
					<div className={classes.divider}></div>
					<PersonaPredictionBox state={state}></PersonaPredictionBox>
				</div>
				<PersonaPopup state={state}></PersonaPopup>
				<DeletePopup state={state}></DeletePopup>
			</div>
		);
	}
}
